import _ from 'lodash'
import Vue from 'vue'
import { rest } from '@woc/woc-repository'
import { Enums } from '@/model/util'

const ENUM_SET = 'setEnumeration'

export const enumerationRepository = {
  get find () { return ENUM_SET }
}

export default {
  state: {},
  actions: {
    [ENUM_SET] (context, payload) {
      if (context.state[payload.id]) {
        return Promise.resolve(context.state[payload.id])
      } else {
        const fragment = _.kebabCase(payload.id)
        return rest.get(`enumerations/${fragment}/values`)
          .then(response => {
            context.commit(ENUM_SET, { type: payload.id, items: response.data.items, model: payload.model })
            return context.state[payload.id]
          })
      }
    }
  },
  mutations: {
    [ENUM_SET] (state, payload) {
      Vue.set(state, payload.type, _.map(payload.items, i => payload.model ? Enums.apply(i, payload.model) : i))
    }
  }
}
